import axios, { AxiosInstance } from 'axios'

import { config } from '../configs/api.config'

import { configureClient } from './api-utils'

let client: AxiosInstance

export interface HubspotCompany {
  company_id: string
  company_name: string | null
  domain: string | null
}

export interface HubspotCompaniesResponse {
  results: HubspotCompany[]
  total: number
}

export const getOrganizationHubspotClient = () => {
  if (!client) {
    client = axios.create({
      baseURL: config.ORGANIZATION
    })

    configureClient(client, {
      baseURL: config.ORGANIZATION
    })
  }

  return client
}

export const organizationHubspotClient = {
  getHubspotCompanies: async (
    search?: string,
    limit: number = 100
  ): Promise<HubspotCompaniesResponse> => {
    const client = getOrganizationHubspotClient()
    const params: Record<string, string | number> = { limit }

    if (search) {
      params.search = search
    }

    const response = await client.get<HubspotCompaniesResponse>(
      '/v2/hubspot/companies',
      { params }
    )

    return response.data
  },

  getHubspotCompanyById: async (
    companyId: string
  ): Promise<HubspotCompany | null> => {
    const client = getOrganizationHubspotClient()

    try {
      const response = await client.get<HubspotCompany>(
        `/v2/hubspot/companies/${companyId}`
      )

      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 404) {
        return null
      }

      throw error
    }
  }
}
